import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.js';

/**
 * Completes the Authorization Code + PKCE exchange after the hosted UI redirects back to
 * /app/callback, then navigates to the originally intended route (§32.1 deep-link return).
 */
export function CallbackPage() {
  const { completeLogin } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // StrictMode double-invoke guard; the code is single-use.
    ran.current = true;
    void (async () => {
      try {
        const returnTo = await completeLogin(window.location.search);
        navigate(returnTo, { replace: true });
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Sign-in failed.');
      }
    })();
  }, [completeLogin, navigate]);

  if (error) {
    return (
      <main className="page center">
        <div className="card">
          <h1>Sign-in failed</h1>
          <p className="error">{error}</p>
          <button type="button" className="action--primary" onClick={() => navigate('/app')}>
            Try again
          </button>
        </div>
      </main>
    );
  }

  return (
    <main className="page center" aria-busy="true">
      <p>Completing sign-in…</p>
    </main>
  );
}
